
function Day19({content}) {

    window.document.body.style.backgroundColor = "#FFFCF9";
    window.document.body.style.color = "#16324f";

  return (
    <div className="day place-items-center content-center" id="daytwelve">
    
                <div className="m-10 p-4 text-4xl lg:text-5xl" >Türchen 19</div>
    <div className="text-xl content-center w-11/12 md:w-1/2 place-items-center">
    <div className="place-items-center w-11/12 lg:w-1/2">
    Wie wärs?..<br/><br/>
    <div className="pb-5">
      Mit einer kleinen Tour durch Wien?<br/><br/>    
    </div>
      </div>
   </div>
    </div>

  );
}

export default Day19;